// extracted by mini-css-extract-plugin
export default {"topFix":"style_topFix__UAngC","bottomFix":"style_bottomFix__UQ6iJ"};